module.exports = __webpack_public_path__ + "media/images/favicon/favicon-e24adef7ca67125b06471d71cb65a61c.ico";